import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import DesignationCandidateModal from './DesignationCandidateModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DesignateHouseholdPrincipalModal',
    props: /*@__PURE__*/ _mergeModels({
        members: {},
        householdName: {}
    }, {
        "modelValue": { type: Boolean, ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["back", "confirm"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        /**
         * "Désigner un nouveau membre principal" modal (OP-7428, parent OP-6527).
         *
         * Shown when the principal member of a household is about to be deleted and 2+ members would
         * remain: OPHUB then requires a `newHouseholdPrincipalContactId` on the SAME delete call
         * (409 `Household.Principal.DesignationRequired` otherwise) — the delete path never auto-promotes.
         * The user picks the new principal among the remaining members; "Confirmer" hands the selected
         * contact id back to the delete-flow orchestrator (ContactDetail.vue), which records it and
         * sends it with the final DELETE. There is no API call from this step, hence no
         * submitting/serverError props (unlike the email-edit designation flow).
         *
         * Thin wrapper over DesignationCandidateModal (single owner of the chrome, shared with the
         * shared-email designation flow): this file only resolves the household i18n namespace and maps
         * ContactDeletionHouseholdMember onto {id: contactId, name}.
         */
        const props = __props;
        const open = _useModel(__props, "modelValue");
        const emit = __emit;
        const { t } = useI18n();
        const tk = (key, params) => t(`contact.detail.designateHouseholdPrincipal.${key}`, params ?? {});
        const items = computed(() => props.members.map((m) => ({ id: m.contactId, name: m.contactName })));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DesignationCandidateModal, {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                items: items.value,
                icon: "ri-home-4-line",
                title: tk('title'),
                subtitle: tk('subtitle', { name: __props.householdName }),
                "mandatory-heading": tk('mandatory'),
                "choose-label": tk('chooseLabel'),
                "item-sublabel": tk('currentlyMember'),
                "selected-badge-label": tk('willBecomePrincipal'),
                "confirm-label": tk('confirm'),
                "back-label": tk('cancel'),
                "unknown-item-label": tk('unknownContact'),
                "testid-prefix": "designate-household-principal",
                onBack: _cache[1] || (_cache[1] = ($event) => (emit('back'))),
                onConfirm: _cache[2] || (_cache[2] = ($event) => (emit('confirm', $event)))
            }, null, 8 /* PROPS */, ["modelValue", "items", "title", "subtitle", "mandatory-heading", "choose-label", "item-sublabel", "selected-badge-label", "confirm-label", "back-label", "unknown-item-label"]));
        };
    }
});
